module.exports = __webpack_public_path__ + "static/media/xslego-7-strategy.bec10cc7.png";